import React from "react";

const ShowLearningFeedback = ({ word, meaning, onContinue, theme }) => {
  const isDark = theme === "dark";
  
  const colors = {
    surface: isDark ? "#1E293B" : "#FFFFFF",
    text: isDark ? "#F1F5F9" : "#1E293B",
    secondaryText: isDark ? "#94A3B8" : "#64748B",
    teal: "#10B981",
    incorrect: isDark ? "#FB7185" : "#E11D48",
    overlay: isDark ? "rgba(0, 0, 0, 0.8)" : "rgba(15, 23, 42, 0.6)",
    border: isDark ? "1px solid #334155" : "1px solid rgba(0, 0, 0, 0.05)"
  };

  return (
    <div style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      background: colors.overlay,
      backdropFilter: "blur(8px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 3000,
      padding: "20px"
    }}>
      <div style={{
        background: colors.surface,
        borderRadius: "32px",
        padding: "36px 32px",
        width: "100%",
        maxWidth: "400px",
        boxShadow: isDark ? "0 25px 50px rgba(0,0,0,0.5)" : "0 25px 50px rgba(0,0,0,0.15)",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        border: colors.border,
        animation: "modalSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
        position: "relative"
      }}>
        {/* HEADER ICON */}
        <div style={{
          width: "64px",
          height: "64px",
          borderRadius: "20px",
          background: isDark ? "rgba(251, 113, 133, 0.1)" : "#FFF1F2",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "20px"
        }}>
          <span style={{ fontSize: "32px" }}>❌</span>
        </div>

        <h3 style={{ 
          color: colors.incorrect, 
          marginTop: 0, 
          marginBottom: "12px", 
          fontSize: "22px", 
          fontWeight: "900",
          letterSpacing: "-0.5px"
        }}>
          Incorrect
        </h3>
        
        <p style={{ 
          fontSize: "16px", 
          marginBottom: "16px", 
          color: colors.secondaryText, 
          fontWeight: "500",
          lineHeight: "1.5"
        }}>
          {typeof word === 'object' && word.isTwins ? (
            <>The synonym pair was:</>
          ) : typeof word === 'object' && word.isToneClash ? (
            <>These words clash:</>
          ) : (
            <>The meaning of <strong style={{ color: colors.text }}>{word}</strong> is:</>
          )}
        </p>

        <div style={{
          background: isDark ? "rgba(16, 185, 129, 0.05)" : "#F0FDFA",
          padding: "20px 24px",
          borderRadius: "20px",
          width: "100%",
          marginBottom: "32px",
          border: `1px solid ${isDark ? "rgba(16, 185, 129, 0.1)" : "#CCFBF1"}`
        }}>
          {typeof word === 'object' && word.isTwins ? (
            <div style={{ textAlign: "left" }}>
              <div style={{ marginBottom: "16px", borderBottom: `1px solid ${isDark ? "#334155" : "#E2E8F0"}`, paddingBottom: "12px" }}>
                <span style={{ fontSize: "16px", fontWeight: "900", color: colors.text }}>{word.word1}</span>
                <p style={{ fontSize: "15px", color: colors.teal, margin: "4px 0 0", fontWeight: "600" }}>{word.meaning1}</p>
              </div>
              <div>
                <span style={{ fontSize: "16px", fontWeight: "900", color: colors.text }}>{word.word2}</span>
                <p style={{ fontSize: "15px", color: colors.teal, margin: "4px 0 0", fontWeight: "600" }}>{word.meaning2}</p>
              </div>
            </div>
          ) : typeof word === 'object' && word.isToneClash ? (
            <div style={{ textAlign: "left" }}>
              <div>
                {/* Temporary Debug Logs */}

                
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
                   <span style={{ fontSize: "16px", fontWeight: "900", color: colors.text }}>{word.word}</span>
                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18 8L22 12L18 16" /><path d="M6 8L2 12L6 16" /><line x1="2" y1="12" x2="22" y2="12" />
                   </svg>
                   <span style={{ fontSize: "16px", fontWeight: "900", color: colors.text }}>{word.clashWord}</span>
                </div>
                <p style={{ fontSize: "14px", color: colors.secondaryText, margin: "4px 0 0", fontWeight: "500" }}>{word.word}: {word.meaning}</p>
              </div>
            </div>
          ) : (
            <p style={{ 
              fontSize: "20px", 
              fontWeight: "800", 
              color: colors.teal, 
              margin: 0,
              lineHeight: "1.4"
            }}>
              {meaning}
            </p>
          )}
        </div>

        <button
          style={{
            width: "100%",
            background: colors.teal,
            color: "white",
            border: "none",
            borderRadius: "18px",
            padding: "18px",
            fontSize: "18px",
            fontWeight: "800",
            cursor: "pointer",
            boxShadow: "0 8px 20px rgba(16, 185, 129, 0.25)",
            transition: "transform 0.2s ease",
            outline: "none"
          }}
          onClick={onContinue}
          onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.02)"}
          onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
        >
          Continue
        </button>

        <style>{`
          @keyframes modalSlideUp {
            from { transform: translateY(20px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
        `}</style>
      </div>
    </div>
  );
};

export default ShowLearningFeedback;
